// 科技特派员静态数据配置
// 这里存储各地区的乡级、科技特派员团队和法人数据
// 后续修改直接修改此文件即可

export const techPersonnelStaticData = {
  // 延平区总体数据
  '延平区': {
    // township: 45, // 乡级科技特派员
    team: 132, // 科技特派员团队
    legalPerson: 14 // 法人科技特派员
  },
  // 各街镇数据
  '西芹镇': {
    // township: 5,
    team: 4,
    legalPerson: 0
  },
  '南山镇': {
    // township: 4,
    team: 15,
    legalPerson: 0
  },
  '四鹤街道': {
    // township: 3,
    team: 5,
    legalPerson: 0
  },
  '塔前镇': {
    // township: 4,
    team: 6,
    legalPerson: 0
  },
  '夏道镇': {
    // township: 5,
    team: 16,
    legalPerson: 2
  },
  '大横镇': {
    // township: 3,
    team: 9,
    legalPerson: 5
  },
  '太平镇': {
    // township: 4,
    team: 1,
    legalPerson: 0
  },
  '峡阳镇': {
    // township: 4,
    team: 4,
    legalPerson: 2
  },
  '巨口乡': {
    // township: 2,
    team: 4,
    legalPerson: 0
  },
  '来舟镇': {
    // township: 2,
    team: 3,
    legalPerson: 0
  },
  '梅山街道': {
    // township: 3,
    team: 2,
    legalPerson: 0
  },
  '樟湖镇': {
    // township: 3,
    team: 3,
    legalPerson: 0
  },
  '水东街道': {
    // township: 3,
    team: 12,
    legalPerson: 1
  },
  '水南街道': {
    // township: 3,
    team: 6,
    legalPerson: 0
  },
  '洋后镇': {
    // township: 2,
    team: 6,
    legalPerson: 0
  },
  '炉下镇': {
    // township: 3,
    team: 7,
    legalPerson: 0
  },
  '王台镇': {
    // township: 5,
    team: 17,
    legalPerson: 3
  },
  '紫云街道': {
    // township: 3,
    team: 1,
    legalPerson: 0
  },
  '茫荡镇': {
    // township: 3,
    team: 5,
    legalPerson: 1
  },
  '赤门乡': {
    // township: 2,
    team: 2,
    legalPerson: 0
  },
  '黄墩街道': {
    // township: 3,
    team: 4,
    legalPerson: 0
  }
};

// 获取指定地区的特派员静态数据
export function getTechPersonnelStaticData (regionName) {
  return techPersonnelStaticData[regionName] || techPersonnelStaticData['延平区'];
}
